import {Base} from "@/api/Base"

export class HolidayAdd extends Base {
    path = "holiday/add"
}